export default "/assets/images/mila-air-3-alt.jpg?cf6c10c0647e02de51c72ead8affc79a";